import controller from './qr-code-generator.controller';
import template from './qr-code-generator.html';

export default {
	template,
	bindings:     {
		value:   '<ngModel',
		options: '<?',
	},
	controller,
	controllerAs: '$ctrl',
	require:      {
		ngModelCtrl: 'ngModel',
	},
};
